const mutations = {
    setToken(state, payload) {
        state.user.token = payload;
    },
    setEvent(state, payload) {
        state.event = payload;
    },
    setDisabled(state, payload) {
        state.disabled = payload;
    },
    setPageCount(state, payload) {
        state.pageCount = payload;
    }
    // setRouts(state, payload) {
    //     state.menuRoutes = payload;
    // }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js